import { logo } from "@/data/site";

const RATIO = {
  square: "aspect-square",
  video: "aspect-video",
  portrait: "aspect-[3/4]",
  wide: "aspect-[16/10]",
  hero: "aspect-[4/5] sm:aspect-[3/4]",
};

// Swappable image placeholder. Pass `src` to show a real image; otherwise a
// tasteful branded placeholder is rendered. Label appears as an editorial tag.
export default function ImagePlaceholder({
  src,
  alt = "",
  label = "IMAGE PLACEHOLDER",
  ratio = "wide",
  className = "",
  rounded = "rounded-2xl",
  testid = "image-placeholder",
}) {
  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden ${rounded} ${RATIO[ratio]} bg-sand ${className}`}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3 p-6 text-center">
          <img src={logo} alt="" className="h-20 w-20 opacity-15" />
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-charcoal/40">
            {label}
          </span>
        </div>
      )}
    </div>
  );
}
